<template>
  <div v-show="isModalVisible">
    <div class="row align-items-center mb-3">
      <div class="col-8">
        <div class="px-2">
          <div class="input-group search_tasks_txtbox">
            <input type="text" class="form-control" placeholder="Search Services or Skills" v-model="searchText" aria-label="Search tasks" @keyup.enter="dosearch()" />
            <div class="input-group-append">
              <span class="input-group-text" v-if="searchTextFlag"><i class="fa fa-close" aria-hidden="true" @click="clearText()"></i></span>
              <span class="input-group-text" v-else><i class="fa fa-search" aria-hidden="true" @click="dosearch()"></i></span>
            </div>
          </div>
        </div>
      </div>
      <div class="col-2 p-0" style="padding-right: 5px !important;">
        &nbsp;
      </div>
      <div class="col-2 p-0" style="padding-right: 20px !important;">
        <div class="text-right ">
          <button class="btn other-tasks-button" @click="addOtherTaskModal()">
            Other Skills
          </button>
        </div>
      </div>
    </div>

    <b-alert
      :show="dismissCountDown"
      dismissible
      variant="success"
      @dismissed="dismissCountDown=0"
      @dismiss-count-down="countDownChanged"
      >
      {{ success_message }}
    </b-alert>


    <div class="col-md-12 p-0" style="margin-top: 10px; padding-left: 10px !important; padding-right: 5px !important;" v-for="option in 3" v-if="tasklists_loading == true && tasklists_focus_loading == true">
      <div class="subtask-wrapper" style="padding-bottom: 5px;">
        <div class="pt-2">
          <div class="col-12 pl-2 pr-0 float-left" >
            <div class="pr-2">
              <PuSkeleton :count="1"></PuSkeleton>
            </div>
            <div class="col-md-12 pt-2 override-padding counter_heading-list heading-wrapper" style="padding-right: 3px; margin-bottom: 0px;">
              <PuSkeleton :count="1"></PuSkeleton>
            </div>
            <div class="col-md-12 pt-1 override-padding counter_heading-list heading-wrapper" style="padding-right: 3px; margin-bottom: 0px;padding-left: 20px;">
              <PuSkeleton :count="1"></PuSkeleton>
            </div>
            <div class="col-md-12 pt-1 override-padding counter_heading-list heading-wrapper" style="padding-right: 3px; margin-bottom: 0px;padding-left: 20px;">
              <PuSkeleton :count="1"></PuSkeleton>
            </div>
          </div>
        </div>
      </div>
    </div>


    <div v-if="focusedSubtasks.length > 0" style="margin-bottom: 7px; float: left; width: 100%;">
      <div class="col-6 p-0 section-title float-left">
          Focused Skills
      </div>
      <div class="col-6 p-0 text-align-right bold float-right" style="padding-right: 5px !important;">{{ taskListsName }} </div>
    </div>
    
    <!-- Focussed Tasklist -->

    <div v-if="focusedSubtasks.length > 0" class="col-md-12 counter_subtask-list p-0" style="margin-top: 10px; padding-left: 10px !important; padding-right: 5px !important;">
      <div v-for = "(focusedSubtask, fsindex) in focusedSubtasks">
        <div class="subtask-wrapper" :id="'subtask-wrapper-' + focusedSubtask.id" style="padding-bottom: 5px;">
          <div class="panel-title focused-section-highlight">
            <div class="col-12 p-0 float-left" >
              <div class="float-left p-0" style="text-align: left !important; padding: 0px 0px 0px 0px !important; width: 5%;" >
                <b-link
                  v-b-toggle="'collapse-focused-' + focusedSubtask.id" class="p-0"  style="padding-left: 10px !important;" @click="getFocusedSecondFontIcon(focusedSubtask.id)">
                    <i class="fa fa-angle-down angle-class" :id="'angle-focused-'+ focusedSubtask.id" aria-hidden="true" ></i>
                </b-link>
              </div>
              <div class="float-left col-5 p-0">
                <b-link
                  v-b-toggle="'collapse-focused-' + focusedSubtask.id" class="p-0"  style="padding-left: 10px !important;" @click="getFocusedSecondFontIcon(focusedSubtask.id)">
                    {{ focusedSubtask.name }}
                </b-link>
              </div>
              <div class="float-left col-3" style="text-align: left; padding: 0px 0px 0px 0px;" v-if="focusedSubtask.id != 99999" >
                <b-link
                  v-b-toggle="'collapse-focused-' + focusedSubtask.id" class="p-0"  style="padding-left: 10px !important;" @click="getFocusedSecondFontIcon(focusedSubtask.id)">
                  <div class="row">
                    <div class="col-9 pr-0">
                      <div class="progress progress_step">
                        <div class="progress-bar" :style="'width: ' + focusedSubtask.subtaskCompetentPercent + '%;'" style="background-color: #B4E6FA !important;" aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                    </div>
                    <div class="col-2 pl-0 pr-1 text-right" style="font-size: 13px; margin-left: 4px;">
                      {{ focusedSubtask.subtaskCompetentPercent }}%
                    </div>
                  </div>
                </b-link>
              </div>
              <div class="float-left col-2 p-0" style="padding-top: 3px !important;" v-if="focusedSubtask.enableAddRep == true">
                <button class="btn subtask-rep-button" @click="openMenteeAddRepModal(focusedSubtask.id, '', 'yes', fsindex, 'Focus')">
                    Add Rep
                </button>
              </div>    
              <div class="float-right p-0 star-class" v-if="focusedSubtask.id != 99999" style=" width: 5%; margin-top: 2px;">
                <i class="fa fa-star"  aria-hidden="true"    data-toggle="tooltip" data-placement="bottom" title="Remove from Focused Section" style="cursor: pointer; color: #ee4200;"></i>
              </div>
              <div style="clear: both;"></div> 
            </div>
          </div>

          <b-collapse v-bind:id="'collapse-focused-' + focusedSubtask.id" class="mt-2 " style="border-top: 1px solid #C8C7C8; float: left; width: 100%; margin-top: 0px !important;">
            <b-card>
              <div class="col-md-12 override-padding counter_heading-list heading-wrapper" v-if="focusedSubtask.headings.length > 0">
                <div v-for = "(focusedHeading, hindex) in focusedSubtask.headings">
                  <b-link  v-b-toggle="'collapse-focused-' + focusedSubtask.id + '-' + focusedHeading.id"  variant="primary" size="sm" class="sub-heading"  @click="getFocusedFontIcon(focusedSubtask.id + '-' + focusedHeading.id)" style="border-bottom: 1px solid #C8C7C8; border-radius: 0; padding-right: 10px;">
                    <i class="fa fa-angle-up" :id="'angle-focused-'+ focusedSubtask.id + '-' + focusedHeading.id" aria-hidden="true"></i>
                    {{ focusedHeading.name }}
                    <div class="float-right col-2 p-0" style="padding: 0 !important; text-align: right;" v-if="focusedHeading.enableAddRep == true">
                    </div>
                    <div class="float-right col-2 p-0" style="padding: 0 !important; text-align: right;" v-if="focusedHeading.enableAddRep == true">
                    <button class="btn subtask-rep-button" @click="openMenteeAddRepModal(focusedHeading.id, '', 'yes', fsindex, 'Focus')">
                      Add Rep
                    </button>
                    </div>    
    
                </b-link>
                <b-collapse v-bind:id="'collapse-focused-' + focusedSubtask.id + '-' + focusedHeading.id" class="mt-2 task-wrapper">
                  <div class="col-md-12 override-padding counter_task-list">
                    <div v-for="(task, index) in focusedHeading.tasks" :key="index" >

                          <b-card class="modal-task">
                            <div class="row" @click="openMenteeAddRepModal(focusedSubtask.id, task.id, 'no', fsindex, 'Focus')" >
                              <div class=""  style="width: 60%; padding-left: 10px;">
                                <div class="task-title">
                                  <span class="counter_task-list__counter"></span>
                                  {{ task.description }}
                                </div>
                              </div>
                              <div v-if="task.goal.goal_rep" class=" task_goal_text" style="width: 12%;">{{ task.goal.task_rep + '/' + task.goal.goal_rep + ' Reps' }}</div>
                              <div  v-if="task.goal.goal_rep_competency" class=" task_goal_text" style="width: 12%; padding-right: 5px;">{{ task.goal.task_rep_competency + '/' + task.goal.goal_rep_competency + ' Comp' }}</div>
                              <div class=""  style="width: 12%;">
                                <button class="btn btn-white task-rep-button" @click="openMenteeAddRepModal(focusedSubtask.id, task.id, 'no', fsindex, 'Focus')" :class="addRepButtonGreenClass(task)">
                                  Add Rep
                                </button>
                              </div>
                            </div>
                          </b-card>

                    </div>
                    <div style="clear: both;"></div>
                  </div>
                </b-collapse>
              </div>
            </div>
            <div class="col-md-12 override-padding counter_task-list task-wrapper" v-if="focusedSubtask.tasks.length > 0" style="margin-top: 5px;">
              <div v-for="(task, index) in focusedSubtask.tasks" :key="index" >

                    <b-card class="modal-task ">
                      <div class="row" @click="openMenteeAddRepModal(focusedSubtask.id, task.id, 'no', fsindex, 'Focus')">
                        <div class=""  style="width: 60%; padding-left: 10px;">
                          <div class="task-title">
                          <span class="counter_task-list__counter"></span>
                          {{ task.description }}
                          </div>
                        </div>
                        <div v-if="task.goal.goal_rep" class=" task_goal_text" style="width: 12%;">{{ task.goal.task_rep + '/' + task.goal.goal_rep + ' Reps' }}</div>
                        <div v-if="task.goal.goal_rep_competency" class=" task_goal_text" style="width: 12%; padding-right: 5px;">{{ task.goal.task_rep_competency + '/' + task.goal.goal_rep_competency + ' Comp' }}</div>
                        <div class=""  style="width: 12%;">
                          <button class="btn btn-white task-rep-button" @click="openMenteeAddRepModal(focusedSubtask.id, task.id, 'no', fsindex, 'Focus')" :class="addRepButtonGreenClass(task)">
                            Add Rep
                          </button>
                        </div>
                      </div>
                    </b-card>

              </div>
              <div style="clear: both;"></div>
            </div>
          </b-card>
        </b-collapse>
      </div>
    </div>
    </div>


    <div v-if="focusedSubtasks.length > 0 && tasklists_focus_loading == false" style="margin-bottom: 7px; float: left; width: 100%;">
      <div class="col-6 p-0 section-title float-left">
          Remaining Skills
      </div>
    </div>
    <div v-else-if="tasklists_focus_loading == false && focusedSubtasks.length == 0 && searchTextFlag == true" style="margin-bottom: 7px; float: left; width: 100%;">
      <div class="col-6 p-0 section-title float-left">
          All Skills
      </div>
      <div class="col-6 p-0 text-align-right bold float-right" style="padding-right: 5px !important;">{{ taskListsName }} </div>
    </div>
    <div v-else-if="tasklists_focus_loading == false" style="margin-bottom: 7px; float: left; width: 100%;">
      <div class="col-6 p-0 section-title float-left">
          All Skills
      </div>
      <div class="col-6 p-0 text-align-right bold float-right" style="padding-right: 5px !important;">{{ taskListsName }} </div>
    </div>
    <!-- Subtask Tasklist -->

    <div v-if="subtasks.length > 0 && directTasks == 1" class="col-md-12 counter_subtask-list" style="margin-top: 10px; padding-left: 10px !important; padding-right: 5px !important;">
      <div v-for = "(subtask, stindex) in subtasks" >
        <div v-if="subtask.name == 'NULL'" class="subtask-wrapper" :id="'subtask-wrapper-' + subtask.id"  style="padding-bottom: 5px;">
          <div class="panel-title focused-section-highlight" style="background-color: #FFF;">
            <div class="col-12 p-0 float-left" >
              <div class="float-left col-4 p-0">
              </div>
              <div class="float-right col-3 mr-3 pr-1 pt-1" style="text-align: left; padding: 0px 0px 0px 0px;" v-if="subtask.id != 99999" >
                  <div class="row">
                    <div class="col-9 pr-0">
                      <div class="progress progress_step">
                        <div class="progress-bar" :style="'width: ' + subtask.subtaskCompetentPercent + '%;'" style="background-color: #B4E6FA !important;" aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                    </div>
                    <div class="col-2 pl-0 pr-1 text-right" style="font-size: 13px; margin-left: 4px; ">
                      {{ subtask.subtaskCompetentPercent }}%
                    </div>
                  </div>
              </div>
              <div style="clear: both;"></div> 
            </div>
          </div>
          <div style="clear: both;"></div> 

                <div class="col-md-12 override-padding counter_task-list task-wrapper" v-if="subtask.tasks.length > 0" style="margin-top: 5px;">
                  <div v-for="(task, index) in subtask.tasks" :key="index" >
                    <b-card class="modal-task ">
                      <div class="row" @click="openMenteeAddRepModal(subtask.id, task.id, 'no', stindex, 'Full')" >
                        <div class=""  style="width: 60%; padding-left: 10px;">
                          <div class="task-title">
                          <span class="counter_task-list__counter"></span>
                          {{ task.description }}
                          </div>
                        </div>
                        <div v-if="task.goal.goal_rep" class=" task_goal_text" style="width: 12%;">{{ task.goal.task_rep + '/' + task.goal.goal_rep + ' Reps' }}</div>
                        <div v-if="task.goal.goal_rep_competency" class=" task_goal_text" style="width: 12%; padding-right: 5px;">{{ task.goal.task_rep_competency + '/' + task.goal.goal_rep_competency + ' Comp' }}</div>
                        <div class=""  style="width: 12%;">
                          <button class="btn btn-white task-rep-button" @click="openMenteeAddRepModal(subtask.id, task.id, 'no', stindex, 'Full')" :class="addRepButtonGreenClass(task)">
                            Add Rep
                          </button>
                        </div>
                      </div>
                    </b-card>
                  </div>
                  <div style="clear: both;"></div>
                </div>
          </div>
        </div>
    </div>

    <div v-if="subtasks.length > 0" class="col-md-12 counter_subtask-list" style="margin-top: 10px; padding-left: 10px !important; padding-right: 5px !important;"">
      <div v-for = "(subtask, stindex) in subtasks">
        <div v-if="subtask.name != 'NULL'" class="subtask-wrapper" :id="'subtask-wrapper-' + subtask.id" style="padding-bottom: 5px;">
          <div class="panel-title focused-section-highlight">
            <div class="col-12 p-0 float-left" >
              <div class="float-left p-0" style="text-align: left !important; padding: 0px 0px 0px 0px !important; width: 5%;" >
                <b-link
                  v-b-toggle="'collapse-' + subtask.id" class="p-0" style="padding-left: 10px !important;" @click="getSecondFontIcon(subtask.id)">
                  <i class="fa fa-angle-down angle-class" :id="'angle-'+ subtask.id" aria-hidden="true" ></i>
                </b-link>
              </div>
              <div class="float-left col-5 p-0">
                <b-link
                  v-b-toggle="'collapse-' + subtask.id" class="p-0" style="padding-left: 10px !important;" @click="getSecondFontIcon(subtask.id)">
                    {{ subtask.name }}
                </b-link>
              </div>
              <div class="float-left col-3" style="text-align: left; padding: 0px 0px 0px 0px;" v-if="subtask.id != 99999" >
                <b-link
                  v-b-toggle="'collapse-' + subtask.id" class="p-0" style="padding-left: 10px !important;" @click="getSecondFontIcon(subtask.id)">
                  <div class="row">
                    <div class="col-9 pr-0">
                      <div class="progress progress_step">
                        <div class="progress-bar" :style="'width: ' + subtask.subtaskCompetentPercent + '%;'" style="background-color: #B4E6FA !important;" aria-valuemin="0" aria-valuemax="100"></div>
                      </div>
                    </div>
                    <div class="col-2 pl-0 pr-1 text-right" style="font-size: 13px; margin-left: 4px; ">
                      {{ subtask.subtaskCompetentPercent }}%
                    </div>
                  </div>
                </b-link>
              </div>
              <div class="float-left col-2 p-0" style="padding-top: 3px !important;" v-if="subtask.enableAddRep == true">
                <button class="btn subtask-rep-button" @click="openMenteeAddRepModal(subtask.id, '', 'yes', stindex, 'Full')">
                    Add Rep
                </button>
              </div>    
              <div class="float-right p-0 star-class" v-if="subtask.id != 99999" style="margin-top: 2px; width: 5%;">
                <i class="fa fa-star-o"  aria-hidden="true"   data-toggle="tooltip" data-placement="bottom" title="Remove from Focused Section" style="cursor: pointer; "></i>
              </div>
              <div style="clear: both;"></div> 
            </div>
          </div>
          <b-collapse v-bind:id="'collapse-' + subtask.id" class="mt-2 " style="border-top: 1px solid #C8C7C8; float: left; width: 100%; margin-top: 0px !important;">
            <b-card>
              <div class="col-md-12 override-padding counter_heading-list heading-wrapper" v-if="subtask.headings.length > 0">
                <div v-for = "(heading, hindex) in subtask.headings">
                  <b-link v-b-toggle="'collapse-' + subtask.id + '-' + heading.id"  variant="primary" size="sm" class="sub-heading"  @click="getFontIcon(subtask.id + '-' + heading.id)" style="border-bottom: 1px solid #C8C7C8; border-radius: 0; padding-right: 10px;">
                    <i class="fa fa-angle-up" :id="'angle-'+ subtask.id + '-' + heading.id" aria-hidden="true"></i>
                    {{ heading.name }}
                    <div class="float-right col-2 p-0" style="padding: 0 !important; text-align: right;" v-if="heading.enableAddRep == true">
                      <button class="btn subtask-rep-button" @click="openMenteeAddRepModal(heading.id, '', 'yes', stindex, 'Full')" >
                          Add Rep
                      </button>
                    </div>    
                  </b-link>
                  <b-collapse v-bind:id="'collapse-' + subtask.id + '-' + heading.id" class="mt-2 task-wrapper">
                    <div class="col-md-12 override-padding counter_task-list">
                      <div v-for="(task, index) in heading.tasks" :key="index" >
                          <b-card class="modal-task">
                            <div class="row" @click="openMenteeAddRepModal(subtask.id, task.id, 'no', stindex, 'Full')" >
                              <div class=""  style="width: 60%; padding-left: 10px;">
                                <div class="task-title">
                                  <span class="counter_task-list__counter"></span>
                                  {{ task.description }}
                                </div>
                              </div>
                              <div v-if="task.goal.goal_rep" class=" task_goal_text" style="width: 12%;">{{ task.goal.task_rep + '/' + task.goal.goal_rep + ' Reps' }}</div>
                              <div v-if="task.goal.goal_rep_competency" class=" task_goal_text" style="width: 12%; padding-right: 5px;">{{ task.goal.task_rep_competency + '/' + task.goal.goal_rep_competency + ' Comp' }}</div>
                              <div class=""  style="width: 12%;">
                                <button class="btn btn-white task-rep-button" @click="openMenteeAddRepModal(subtask.id, task.id, 'no', stindex, 'Full')" :class="addRepButtonGreenClass(task)">
                                  Add Rep
                                </button>
                              </div>
                            </div>
                          </b-card>
                        </div>
                        <div style="clear: both;"></div>
                      </div>
                    </b-collapse>
                  </div>
                </div>
                <div class="col-md-12 override-padding counter_task-list " v-if="subtask.tasks.length == 0 && subtask.id == 99999" style="margin-top: 5px;">
                  <b-card class="modal-task " >
                    <div class="row">
                      <div class=""  style="width: 60%; padding-left: 80px;">
                        No other task added.
                      </div>
                    </div>
                  </b-card>  
                </div>

                <div class="col-md-12 override-padding counter_task-list task-wrapper" v-if="subtask.tasks.length > 0" style="margin-top: 5px;">
                  <div v-for="(task, index) in subtask.tasks" :key="index" >
                    <b-card class="modal-task ">
                      <div class="row" @click="openMenteeAddRepModal(subtask.id, task.id, 'no', stindex, 'Full')" >
                        <div class=""  style="width: 60%; padding-left: 10px;">
                          <div class="task-title">
                          <span class="counter_task-list__counter"></span>
                          {{ task.description }}
                          </div>
                        </div>
                        <div v-if="task.goal.goal_rep" class=" task_goal_text" style="width: 12%;">{{ task.goal.task_rep + '/' + task.goal.goal_rep + ' Reps' }}</div>
                        <div v-if="task.goal.goal_rep_competency" class=" task_goal_text" style="width: 12%; padding-right: 5px;">{{ task.goal.task_rep_competency + '/' + task.goal.goal_rep_competency + ' Comp' }}</div>
                        <div class=""  style="width: 12%;">
                          <button class="btn btn-white task-rep-button" @click="openMenteeAddRepModal(subtask.id, task.id, 'no', stindex, 'Full')" :class="addRepButtonGreenClass(task)">
                            Add Rep
                          </button>
                        </div>
                      </div>
                    </b-card>
                  </div>
                  <div style="clear: both;"></div>
                </div>
              </b-card>
            </b-collapse>
          </div>
        </div>
      </div>

      <MenteeTasklistsOtherTask 
        :isModalVisible="isOtherTaskModalVisible"
        :taskListName="taskListsName"
        :menteeId="menteeId"
        :taskListId="taskListId"
        @closeTaskListOtherTasksModal="closeTaskListOtherTasksModal"
        ref="TaskListOtherTaskModal">
      </MenteeTasklistsOtherTask>
      <div v-if="isMenteeAddRepModalVisible">
      <MenteeAddRep
        :isModalVisible="isMenteeAddRepModalVisible"
        @closeMenteeAddRepModal="closeMenteeAddRepModal"
        @closeMenteeEditRepModal="closeMenteeEditRepModal"
        ref="MenteeAddRepModal">
      </MenteeAddRep>
      </div>


  </div>
</template>

<script>
import axios from 'axios';
import MenteeTasklistsOtherTask from '@/components/manager/mentee_tasklist_add_othertask_modal.vue';
import MenteeAddRep from '@/components/mentee/mentee_add_rep.vue';

export default {
  props: ['isModalVisible'],
  data() {
    return {
      menteeFirstName: '',
      menteeShortName: '',
      repCount: '',
      repTasks: '',
      mentorsAssigned: [],
      viewAll: false,
      searchText: '',
      subtasks: [],
      focusedSubtasks: [],
      searchTextFlag: false,
      tasklists_loading: false,
      tasklists_focus_loading: false,
      isSkillPassModalVisible: false,
      taskListsName: '',
      menteeId: '',
      taskListId: '',
      isOtherTaskModalVisible: false,
      isMenteeAddRepModalVisible: false,
      isSection: '',
      taskId: '',
      subTaskId: '',
      success_message: '',
      dismissCountDown: 0,
      directTasks: 0,
    }
  },
  computed: {
    
  },
  components: {
    MenteeTasklistsOtherTask,
    MenteeAddRep,
  },
  methods: {
    addRepButtonGreenClass(task) {
      if (task.completed == 1 || (task.goal.task_rep_competency !== undefined && 
        task.goal.goal_rep_competency !== undefined && 
        task.goal.task_rep_competency != 0 && 
        task.goal.goal_rep_competency != 0 && 
        (task.goal.task_rep_competency >= task.goal.goal_rep_competency))
      ) {
        return 'add_rep_button_green';
      }
    },
    countDownChanged(dismissCountDown) {
      this.dismissCountDown = dismissCountDown
    },
    openMenteeAddRepModal(subTaskId, taskId, isSection, subtaskIndex, type) {
      this.isMenteeAddRepModalVisible = true;
      setTimeout(() => {
      this.$refs.MenteeAddRepModal.getRepData(this.taskListId, subTaskId, taskId, this.menteeId, isSection, subtaskIndex, type);
      }, 500);
      
    },  
    closeMenteeAddRepModal(subtaskIndex, type, flag) {
      if(flag == 1) {
        this.success_message = 'Rep added successfully.';
        this.dismissCountDown = 5;
      }
      this.$emit('closeAddRep');
      this.isMenteeAddRepModalVisible = false;
    },
    closeMenteeEditRepModal(subtaskIndex, type) {
      this.isMenteeAddRepModalVisible = false;
    },
    closeTaskListOtherTasksModal(flag) {
      this.isOtherTaskModalVisible = false;
      if(flag == 1) {
        this.success_message = 'Other skill added successfully.';
        this.dismissCountDown = 5;
      }
      this.showFocusedSectionOfMentee();
      this.$emit('closeAddRep');
      this.showAssessmentofTasklist();
    },
    openSkillPass() {
      this.isSkillPassModalVisible = false;
      this.$emit('openSkillPassModal');
    },
    addOtherTaskModal() {
      this.$refs.TaskListOtherTaskModal.clearData();
      this.isOtherTaskModalVisible = true;
    },
    getUpdatedSubtask(subtaskIndex, type) {
      if(type == 'Full') {
        var subtask_obj = this.subtasks[subtaskIndex];
      }
      else {
        var subtask_obj = this.focusedSubtasks[subtaskIndex];
      }
      axios('/desktop/v2/get-subtask-details', {
        method: 'GET',
        params: {
          account_id: this.$store.state.user_accountid, 
          mentee_id: this.menteeId,
          tasklist_id: this.taskListId,
          subtask_id: subtask_obj.id,        
        }
      })
      .then(resp => {
        let data = resp.data;
        if(type == 'Full') {
          this.subtasks[subtaskIndex].id = data.id;
          this.subtasks[subtaskIndex].name = data.name;
          if(data.directTask == 1) {
            this.directTasks = 1;
          }
          this.subtasks[subtaskIndex].enableAddRep = data.enableAddRep;
          this.subtasks[subtaskIndex].focusedSectionId = data.focusedSectionId;
          this.subtasks[subtaskIndex].goalEdit = data.goalEdit;
          this.subtasks[subtaskIndex].headings = data.headings;
          this.subtasks[subtaskIndex].tasks = data.tasks;
          this.subtasks[subtaskIndex].subtaskCompetentPercent = data.subtaskCompetentPercent;
          this.subtasks[subtaskIndex].menteeRepHours = data.menteeRepHours;
        }
        else {
          this.focusedSubtasks[subtaskIndex].id = data.id;
          this.focusedSubtasks[subtaskIndex].name = data.name;
          this.focusedSubtasks[subtaskIndex].enableAddRep = data.enableAddRep;
          this.focusedSubtasks[subtaskIndex].focusedSectionId = data.focusedSectionId;
          this.focusedSubtasks[subtaskIndex].goalEdit = data.goalEdit;
          this.focusedSubtasks[subtaskIndex].headings = data.headings;
          this.focusedSubtasks[subtaskIndex].tasks = data.tasks;
          this.focusedSubtasks[subtaskIndex].subtaskCompetentPercent = data.subtaskCompetentPercent;
          this.focusedSubtasks[subtaskIndex].menteeRepHours = data.menteeRepHours;
        }
        
      })
      .catch(() => {});
    },
    getFontIcon(id) {
      if (document.getElementById('collapse-' + id).style.display == "") {
        document.getElementById('angle-'+ id).className = "fa fa-angle-down";
      } else {
        document.getElementById('angle-'+ id).className = "fa fa-angle-left";
      }
    },
    getSecondFontIcon(id) {
      if (document.getElementById('collapse-' + id).style.display == "") {
        document.getElementById('angle-'+ id).className = "fa fa-angle-down angle-class";
        document.getElementById('subtask-wrapper-'+ id).className = "subtask-wrapper";
      } else {
        document.getElementById('angle-'+ id).className = "fa fa-angle-left angle-class";
        document.getElementById('subtask-wrapper-'+ id).className = "subtask-wrapper bg-grey";
      }
    },  
    getFocusedFontIcon(id) {
      if (document.getElementById('collapse-focused-' + id).style.display == "") {
        document.getElementById('angle-focused-'+ id).className = "fa fa-angle-down";
      } else {
        document.getElementById('angle-focused-'+ id).className = "fa fa-angle-left";
      }
    },
    getFocusedSecondFontIcon(id) {
      if (document.getElementById('collapse-focused-' + id).style.display == "") {
        document.getElementById('angle-focused-'+ id).className = "fa fa-angle-down angle-class";
        document.getElementById('subtask-wrapper-'+ id).className = "subtask-wrapper";
      } else {
        document.getElementById('angle-focused-'+ id).className = "fa fa-angle-left angle-class";
        document.getElementById('subtask-wrapper-'+ id).className = "subtask-wrapper bg-grey";
      }
    },
    showFocusedSectionOfMentee() {
       this.focusedSubtasks = [];
       this.tasklists_focus_loading = true;
       axios.get('/mentee/focusedsection/' + this.menteeId + '/' + this.taskListId + '/' + this.$store.state.user_accountid)
        .then(response =>  {          
            this.focusedSubtasks = response.data.subtasks;        
            if(this.focusedSubtasks.length == 0) {
              this.tasklists_focus_loading = true; 
            }
            else {
              this.tasklists_focus_loading = false; 
            }
        })
        .catch(function(error) {

        });
    },
    showAssessmentofTasklist() {
       this.tasklists_loading = true;
       this.subtasks = [];
       axios.get('/desktop/mentees_tasklists_detail/' + this.menteeId + '/' + this.taskListId + '/' + this.$store.state.user_accountid)
        .then(response =>  {
            this.tasklists_loading = false;
            this.tasklists_focus_loading = false;
            this.subtasks = response.data.subtasks;
            for(var i=0; i<this.subtasks.length; i++) {
              if(this.subtasks[i].directTask == 1) {
                this.directTasks = 1;
              }
            }
            this.taskListsName = response.data.title;
        })
        .catch(function(error) {

        });
    },
    getTaskListData(menteeId, taskListId) {
      this.menteeId = menteeId;
      this.taskListId = taskListId;
      this.searchText = '';
      this.subtasks = [];
      this.focusedSubtasks = [];
      this.tasklists_loading = true;
      this.tasklists_focus_loading = true;
      this.searchTextFlag = false;
      this.showFocusedSectionOfMentee();
      this.showAssessmentofTasklist();
    },
    clearText() {
      this.searchText = '';
      this.subtasks = [];
      this.focusedSubtasks = [];
      this.tasklists_loading = true;
      this.tasklists_focus_loading = true;
      this.searchTextFlag = false;
      this.showFocusedSectionOfMentee();
      this.showAssessmentofTasklist();
    },
    dovalidate() {
      var flag = 1;
      if(this.searchText == '') {
        alert("Please enter search text");
        flag = 0;
        return false;
      }
      if(this.searchText.length < 3) {
        alert("Search text should be minimum 3 characters");
        flag = 0;
        return false;
      }
      return flag;
    },
    dosearch() {
      var flag = this.dovalidate();
      if(flag == 1) {
       this.searchTextFlag = true;
       this.subtasks = [];
       this.focusedSubtasks = [];
       this.tasklists_loading = true;
       this.tasklists_focus_loading = true;
       axios.get('/desktop/mentees_tasklists_search/' + this.menteeId + '/' + this.taskListId + '/' + this.$store.state.user_accountid, {
          params: {
            searchText: this.searchText,
          }
        })
        .then(response =>  {
          this.loading = false;
          this.tasklists_loading = false;
          this.tasklists_focus_loading = false;
          this.subtasks = response.data.subtasks;
          for(var i=0; i<this.subtasks.length; i++) {
            if(this.subtasks[i].directTask == 1) {
              this.directTasks = 1;
            }
          }
          this.focusedSubtasks = response.data.focusSubtasks;
          this.repCount = response.data.rep_count;
        })
        .catch(function(error) {

        });
      }
        
    },  

  },
}
</script>

<style scoped>


.subtask-wrapper {
  border: 1px solid #C8C7C8;
  background-color: #FFF;
  float: left;
  width: 100%;
  margin-bottom: 10px;
  border-radius: 5px;
}
.bg-grey {
  background-color: #F0F0F0;
}
.star-class {
  padding-top: 3px !important;
}
.heading-wrapper {
  border: 0;
  float: left;
  width: 95%;
  margin-bottom: 10px;
  margin-left: 4%;
  margin-right: 1%;
  border-radius: 5px;
}
.sub-heading {
  background: none;
  font-size: 14px;
  color: #002F42 !important;
  font-weight: normal;
  padding-left: 0px;
  padding-top: 8px;
  padding-bottom: 4px;
  margin-left: 8px;
}
.sub-heading i {
  float: none;
}
a.sub-heading i{
  color: #002F42 !important;
  font-weight: normal;
  font-size: 14px;
  padding-left: 0px;
  padding-right: 10px;
  border-radius: 5px;

}
.task-wrapper .card {
  font-weight: normal;
  border: 0px solid #C8C7C8;
  background-color: #FFF;
  margin-left: 5px;
  margin-right: 5px;
}
.task_goal_text {
  padding-top: 5px;
}
.task-rep-button {
  height: 21px; width: 94%; font-size: 12px; padding: 0; border-radius: 15px; margin-top: 5px; margin-right: 5px;
}
.other-tasks-button {
  height: 30px; width: 85%; font-size: 12px; padding: 0; border-radius: 15px; margin-top: 1px; margin-right: 5px; margin-left: 20px;
  color: #FFF !important;
}
.subtask-rep-button {
  height: 20px; width: 65%; font-size: 12px; padding: 0; border-radius: 15px; margin-top: 1px; margin-right: 5px; margin-left: 20px;
  color: #FFF;
}
.progress {
  background-color: #DDD;
}
.save-goal-button {
  color: #2EACEE;
  font-weight: bold;
  cursor: pointer;
  margin-top: 4px;
}

.search_tasks_txtbox input {
  height: 30px;
  border-right: 0;
  width: 125px !important;
  font-size: 12px;
  border-radius: 10px;
  border-color: #ced4da !important;
}
.search_tasks_txtbox input:active,
.search_tasks_txtbox input:focus,
.search_tasks_txtbox input:hover {
  border-color: #ced4da !important;
}
.search_tasks_txtbox .input-group-text {
  background-color: #FFFFFF;
  color: lightgray;
  border-radius: 10px;
  padding-bottom: 0px;
  padding-top: 0px;
  border-top-left-radius: 0;
  border-bottom-left-radius: 0;
  border-color: #ced4da !important;
}
.panel-title a {
  font-size: 14px;
  color: #002F42 !important;
  font-weight: normal;
  padding-left: 0px;
}

a {
  cursor: pointer;
}
.progress_step {
  height:10px;
  margin-top: 5px;
}
.section-title {
  text-transform: uppercase;
  font-weight: bold;
  font-size: 14px;
  padding-left: 10px !important;
}
.add_rep_button_green {
  color: #fff !important;
  background-color: #28a745 !important;
  border-color: #28a745 !important;
}
</style>


// WEBPACK FOOTER //
// src/components/mentee/mentee_tasklist_component.vue